<template>
  <tool-container 
  :title="'输入底物数据'">
      <el-tabs
        @tab-click="switchTab"
        v-model="activeName">
          <el-tab-pane 
          label="表格输入"
          name="table-input">
              <tool-table ref="tableInput"></tool-table>    
          </el-tab-pane>
          <el-tab-pane 
          label="文字输入"
          name="text-input">
              <tool-input ref="textInput"></tool-input> 
          </el-tab-pane>
      </el-tabs>
      <div class="button-container mt-15">
          <el-button
              type="primary" 
              @click="geneOAT()"
              :loading="loading"
              icon="el-icon-s-promotion">
          生成正交用例
          </el-button>
          <el-button
              @click="resetInput()"
              icon="el-icon-refresh-right">
              重置输入
          </el-button>
          <div class="split"></div>
          <el-button
              @click="importData(0)"
              icon="el-icon-document">
              导入示例数据
          </el-button>
      </div>
  </tool-container>
</template>

<script>
import ToolContainer from '../components/tool-container.vue'
import ToolTable from '../components/table-input.vue'
import ToolInput from '../components/text-input.vue'
import oat from "../utils/OAT"

export default {
  components: {
    ToolContainer,
    ToolTable,
    ToolInput,
  },
  data() {
    return {
      activeName: "table-input",
      loading: false
    };
  },
  methods: {
    visit(route) {
                    var xhr=new XMLHttpRequest();
                    xhr.open('POST','/api/visit',true);
                    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                    xhr.send('route='+route )
                },
    switchTab(tab) {
      if (tab.name === "text-input") {
        this.$refs.textInput.getData();
      } else if (tab.name === "table-input") {
        this.$refs.tableInput.getData();
      }
    },
    geneOAT() {
      this.loading = true;
      
      this.$store.commit("reset", {
        type: "headers",
      });
      
      let values = JSON.parse(JSON.stringify(this.$store.state.values));
      
      values.forEach((arr) => {
        this.$store.commit("pushHeader", {
          v: arr.splice(0, 1)[0]
        })
      }); 
      
      oat(values, (values, matrix) => this.getRes(values, matrix), (err) => {
        this.loading = false;
        this.$message({
          type: 'error',
          message: err
        });  
      });
    },
    getRes(values, matrix) {
      this.$store.commit("reset", {
        type: "res",
      });
      
      let res = [];
      
      matrix.forEach(arr => {
        let t = arr.map((v, i) => {
          if (i >= values.length) return
          if (v >= values[i].length) {
            return values[i][v % values[i].length];    
          } else {
            return values[i][v];
          }
        }).filter(v => v != undefined);
        res.push(t);
      });
      
      // 去除重复的用例
      res = res.reduce((acc, v) => {
        if (!acc.some(x => JSON.stringify(x) == JSON.stringify(v))) acc.push(v);
        return acc;
      }, []);
      
      // 加入表头
      res.unshift(this.$store.state.headers);
      
      this.$store.commit("changeData", {
        type: "res",
        value: res
      });
      
      this.visit(encodeURIComponent(JSON.stringify(this.$store.state.headers)+JSON.stringify(values)))
      this.loading = false;
      this.$message({
        type: 'success',
        message: '获取成功!'
      });

      // console.log(JSON.stringify(values), JSON.stringify(matrix), JSON.stringify(res));
    },
    resetInput() {
      this.$confirm('此操作将重置您输入的数据, 是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.commit("reset", {
          type: "values",
        });
        this.$store.commit("reset", {
          type: "res",
        });
        
        this.syncData();
        
        this.$message({
          type: 'success',
          message: '重置成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消重置'
        });          
      });
    },
    importData(index) {
      const demoData = [[
      ["温度(摄氏度)", "70","75","80", "85","90"],
      ["时间(min)", "80","90", "100","110","120"],
      ["催化剂含量(%)","4", "5", "6","7","8"],
      ["搅拌转速","100", "300", "500","700","1000"]]
      ];
      
      this.$store.commit("changeData", {
        type: "values",
        value: demoData[index]
      });
      
      this.syncData();
      
      this.$message({
        type: "success",
        message: "导入成功！"
      })
      
    },
    syncData() {
      this.$refs.tableInput.getData();
      this.$refs.textInput.getData();
    }
  },
  computed: {
    hasRes() {
      return this.$store.state.res.length ? true : false;
    }
  }   
}
</script>